import { render, staticRenderFns } from "./leftData.vue?vue&type=template&id=a171704c&scoped=true"
import script from "./leftData.vue?vue&type=script&lang=js"
export * from "./leftData.vue?vue&type=script&lang=js"
import style0 from "./leftData.vue?vue&type=style&index=0&id=a171704c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a171704c",
  null
  
)

export default component.exports